import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { AxiosError } from 'axios'
import lateArrivalReportApi from '../../../middleware/api/TimeAndAttendance/LateArrivalReport/lateArrivalReportApi'
import { LoadingState, ValidationError } from '../../../types/commonTypes'
import {
  GetLateArrivalReportResponse,
  LateArrivalReportApiProps,
  LateArrivalReportSliceState,
} from '../../../types/TimeAndAttendance/LateArrivalReport/lateArrivalReportTypes'
import { ApiLoadingState } from '../../../middleware/api/apiList'
import { RootState } from '../../../stateStore'

const getEmployeeLateComings = createAsyncThunk(
  'lateArrivalReport/getEmployeeLateComings',
  async (props: LateArrivalReportApiProps, thunkApi) => {
    try {
      return await lateArrivalReportApi.getEmployeeLateComings(props)
    } catch (error) {
      const err = error as AxiosError
      return thunkApi.rejectWithValue(err.response?.status as ValidationError)
    }
  },
)

const initialLateArrivalReportState: LateArrivalReportSliceState = {
  isLoading: ApiLoadingState.idle,
  listSize: 0,
  getLateArrivalReportResponse: {} as GetLateArrivalReportResponse,
}

const lateArrivalReportSlice = createSlice({
  name: 'lateArrivalReport',
  initialState: initialLateArrivalReportState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getEmployeeLateComings.fulfilled, (state, action) => {
        state.isLoading = ApiLoadingState.succeeded
        state.getLateArrivalReportResponse = action.payload
      })
      .addCase(getEmployeeLateComings.pending, (state) => {
        state.isLoading = ApiLoadingState.loading
      })
      .addCase(getEmployeeLateComings.rejected, (state) => {
        state.isLoading = ApiLoadingState.failed
      })
  },
})

const listSize = (state: RootState): number => state.lateArrivalReport.listSize

const isLoading = (state: RootState): LoadingState =>
  state.lateArrivalReport.isLoading

const getLateArrivalReportResponse = (
  state: RootState,
): GetLateArrivalReportResponse =>
  state.lateArrivalReport.getLateArrivalReportResponse

const lateArrivalReportThunk = {
  getEmployeeLateComings,
}

const lateArrivalReportSelectors = {
  listSize,
  isLoading,
  getLateArrivalReportResponse,
}

export const lateArrivalReportService = {
  ...lateArrivalReportThunk,
  actions: lateArrivalReportSlice.actions,
  selectors: lateArrivalReportSelectors,
}

export default lateArrivalReportSlice.reducer
